<script lang="ts">
	import IndexedInfoCard from '$lib/components/Card/IndexedInfoCard.svelte';
	import SectionInformationBlock from '$lib/components/Contentblocks/SectionInformationBlock.svelte';
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';

	export let cards: Array<{ name: string; description: string }>;
	export let additionalClass: string = '';
	export let id: string = '';

	const { t } = getTranslate();

	$: sectionTitle = $t('section-title.who.course-detail');
	$: title = $t('title.who.course-detail');
	// $: description = $t('description.who.course-detail');
</script>

{#if cards && cards.length > 0}
	<SectionInformationBlock
		additionalClass={classes(additionalClass, '')}
		{id}
		{sectionTitle}
		{title}
	>
		<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-14">
			{#each cards as { name, description }, index}
				<IndexedInfoCard title={name} {description} {index} />
			{/each}
		</div>
	</SectionInformationBlock>
{/if}
